import React, { useState } from "react";
import { Col, Row, Form, Button, message } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import UserPassword from "./account_password_new";
import UserPasswordOld from "./account_password_old";
import UserPasswordConfirm from "./account_password_confirm";
import { checkUpdatePassword } from "../../../store/auth/auth.action";

const wrapperCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 18,
    offset: 0,
  },
};

const labelCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 6,
    offset: 0,
  },
};

const resetData = (form) => {
  const values = {
    password: "",
    oldPassword: "",
    confirm: "",
  };
  form.setFieldsValue(values);
};

const AccountFormPassword = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const { t } = useTranslation("translation", { keyPrefix: "account" });
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------

  const handleEdit = () => {
    setEdit(true);
  };

  const handleCancel = () => {
    setEdit(false);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION --------------------------

  const onFinish = (values) => {
    const { password, oldPassword } = values;
    setLoading(true);
    dispatch(
      checkUpdatePassword({ password, oldPassword }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Update Password successfully!");
          setEdit(false);
          resetData(form);
        }
        if (response?.status === 500) {
          message.error(response?.data || "Failed");
        }
      })
    );
  };
  const onFinishFailed = (error) => {};

  // -------------------------- RENDER --------------------------

  const renderForm = () => {
    const disabled = loading || !edit;
    if (!edit) {
      return (
        <Form labelCol={labelCol} wrapperCol={wrapperCol} name="password_form" autoComplete="off">
          <Row gutter={[16, 0]}>
            <Col xl={24} lg={24} md={24} xs={24}>
              <UserPasswordOld disabled={disabled} />
            </Col>
            <Col xl={24} lg={24} md={24} xs={24}>
              {renderEditButton()}
            </Col>
          </Row>
        </Form>
      );
    }
  };

  const renderEditButton = () => {
    return (
      <Row gutter={[16, 5]} justify="end" align="center">
        <Col>
          <Button
            type="primary"
            className="login-form-button form-button"
            loading={loading}
            onClick={() => handleEdit()}
          >
            {t("edit")}
          </Button>
        </Col>
      </Row>
    );
  };

  const renderChangeForm = () => {
    const disabled = loading;
    if (edit) {
      return (
        <Form
          labelCol={labelCol}
          wrapperCol={wrapperCol}
          name="password_edit_form"
          autoComplete="off"
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={[16, 5]}>
            <Col xl={24} lg={24} md={24} xs={24}>
              <UserPasswordOld disabled={disabled} />
            </Col>
            <Col xl={24} lg={24} md={24} xs={24}>
              <UserPassword disabled={disabled} />
            </Col>
            <Col xl={24} lg={24} md={24} xs={24}>
              <UserPasswordConfirm disabled={disabled} />
            </Col>
            <Col xl={24} lg={24} md={24} xs={24}>
              {renderSaveButton()}
            </Col>
          </Row>
        </Form>
      );
    }
  };

  const renderSaveButton = () => {
    return (
      <Row gutter={[16, 5]} justify="end" align="center">
        <Col>
          <Button
            className="login-form-button form-button"
            disabled={loading}
            onClick={() => handleCancel()}
          >
            {t("cancel")}
          </Button>
        </Col>
        <Col>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button form-button save"
              loading={loading}
            >
              {t("save")}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 5]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderForm()}
        {renderChangeForm()}
      </Col>
    </Row>
  );
};

export default AccountFormPassword;
